import BaseMiddleware from "src/middleware/BaseMiddleware";
import { types as authType } from "src/store/modules/Auth.module";
import store from "src/store";

class AuthMiddleware extends BaseMiddleware {
	static goToLogin (next, to, loginPage = "login-page") {
		return next({
			name: loginPage,
			query: to.query,
		});
	}

	async handle (next, to, from) {
		let loginPage = "login-page";
		const authRoute = to.matched.find(m => m.meta.RequireAuth);
		if (authRoute && authRoute.meta.RequireAuth.loginPage) {
			loginPage = authRoute.meta.RequireAuth.loginPage;
		}
		if (!store.getters.isConnected) {
			try {
				await store.dispatch(authType.GET);
				if (!store.getters.isConnected) {
					return AuthMiddleware.goToLogin(next, to, loginPage);
				} else {
					return next();
				}
			} catch (e) {
				return AuthMiddleware.goToLogin(next, to, loginPage);
			}
		} else {
			return next();
		}
	}
}

export const rules = {};
AuthMiddleware.rules = {
	CLIENT: "client",
	ADMIN: "admin",
};

export default AuthMiddleware;
